import * as PIXI from 'pixi.js';
import { Bubble, BubbleType } from '../../bubbles/types';
import { Place } from 'js/bubbleCore/types';
import { BubbleViewHandler } from './BubbleViewHandler';
import { createViewHandler } from './createViewHandler';
import { TweenManager } from 'framework/TweenManager/TweenManager';
import { TweenStack } from 'framework/TweenManager/TweenStack';
import { BubbleGameBoardView } from 'js/bubbleCore/view/BubbleGameBoardView';
import { BoardAnimationLayer } from 'js/bubbleCore/view/BoardAnimationLayer';
import { IEvent } from 'js/bubbleCore/events';

interface IBubbleViewConfig {
  boardView: BubbleGameBoardView,
  debug?: {
    hexSize: number;
  }
}

export class BubbleView extends PIXI.Container {
  public readonly boardView: BubbleGameBoardView;
  public readonly tweenManager: TweenManager;
  public readonly animationLayer: BoardAnimationLayer;

  public readonly pivotTweenStack: TweenStack;
  private readonly config: IBubbleViewConfig;
  private viewHandler: BubbleViewHandler<BubbleType>;
  private model: Bubble | null = null;

  constructor(config: IBubbleViewConfig) {
    super();
    this.boardView = config.boardView;
    this.tweenManager = this.boardView.tweenManager;
    this.animationLayer = this.boardView.animationLayer;
    this.pivotTweenStack = config.boardView.tweenManager.createTweenStack(this.pivot);
    this.config = config;
  }

  public reset(model: Bubble) {
    if (this.viewHandler) this.viewHandler.cleanup();

    this.model = model;
    this.viewHandler = createViewHandler(this, model);
    this.viewHandler.initView();
    if (this.config.debug) {
      this.debugAddRadius(this.config.debug.hexSize);
    }
  }

  public async animateKill(event: IEvent): Promise<void> {
    if (!this.viewHandler) return;
    await this.viewHandler.animateKill(event);
  }

  public animatePopOut(): void {
   if (!this.viewHandler) return;
    this.viewHandler.animatePopOut(); 
  }

  public debugAddRadius(hexSize: number): void {
    if (!this.model) return;
    const gfx = new PIXI.Graphics();
    this.addChild(gfx);

    const updateRadius = () => {
      if (!this.model) {
        gfx.destroy();
        return;
      }
      gfx.clear();
      gfx.lineStyle(2, 0xff0000);
      const radius = this.model.place === Place.Grid ? this.model.radiusInGrid : this.model.radius;
      gfx.drawCircle(0, 0, radius * hexSize);
      requestAnimationFrame(updateRadius);
    };
    requestAnimationFrame(updateRadius);
  }

  public getModel(): Bubble | null {
    return this.model;
  }
}